import { type ApiError, useApi } from '@omnipresentgroup/api';
import type {
  GetXeroOrganisationsResponseAPI,
  XeroOrganisation,
} from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import {
  XERO_INTEGRATION_API_BASE,
  XERO_INTEGRATION_API_PATH,
  XERO_INTEGRATION_ORGANISATIONS_PATH,
} from '../constants';
import { transformXeroOrganisationsFromAPI } from '../mappers';

export const getXeroOrganisationsKey = (clientId: string) => [
  XERO_INTEGRATION_API_PATH,
  clientId,
  XERO_INTEGRATION_ORGANISATIONS_PATH,
];

export const useXeroOrganisations = ({ clientId }: { clientId: string }) => {
  const { GET } = useApi();
  const query = useQuery<
    GetXeroOrganisationsResponseAPI,
    ApiError,
    XeroOrganisation[]
  >({
    queryKey: getXeroOrganisationsKey(clientId),
    queryFn: () =>
      GET<GetXeroOrganisationsResponseAPI>(
        `${XERO_INTEGRATION_API_BASE}/${XERO_INTEGRATION_API_PATH}/${clientId}/${XERO_INTEGRATION_ORGANISATIONS_PATH}`,
      ),
    select: transformXeroOrganisationsFromAPI,
    enabled: !!clientId,
  });

  return query;
};
